import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createBadgeCol,
  createCustomCol,
  createDateHasAllTimeCol,
  createDateRangeCol,
  createDetailButtonColV2,
  createIdCol,
  createIndexCol,
  createNumberCol,
  createStatusBadgeCol,
  createTypoCol,
  createViewableCol,
} from '@/src/helpers/agColumnHelper';
import { formatter } from '@/src/utils/formatter';
import { EntryType } from '@/src/models/EntryDto';
import { UNIT_STRINGS } from '@/src/constants/unit';

export const entryListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateRangeCol({
    field: 'startedAt',
    keys: ['startedAt', 'endedAt'],
    size: 'lg',
    flex: 1,
    headerName: '응모 기간',
  }),
  createViewableCol({
    field: 'isExposed',
    headerName: '노출 여부',
  }),
  createStatusBadgeCol({
    field: 'priorityDisplayYn',
    type: 'isApplied',
    size: 'sm',
    headerName: '우선 노출 여부',
  }),
  createBadgeCol({
    field: 'type',
    size: 'sm',
    options: [
      {
        value: EntryType.DAILY,
        label: '매일 참여',
        color: 'lightPink',
      },
      {
        value: EntryType.NORMAL,
        label: '이벤트',
        color: 'lightPurple',
      },
      {
        value: EntryType.FIRST_SERVED,
        label: '선착순',
        color: 'lightBlue',
      },
      {
        value: EntryType.FREE,
        label: '무료',
        color: 'lightYellow',
      },
    ],
    headerName: '유형',
  }),
  createTypoCol({
    field: 'title',
    size: 'lg',
    flex: 2,
    headerName: '제목',
  }),

  createNumberCol({
    field: 'entryCredit',
    size: 'md',
    headerName: `1회 응모 크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createNumberCol({
    field: 'participantsCredit',
    size: 'md',
    headerName: `누적 크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createNumberCol({
    field: 'participantsCnt',
    size: 'sm',
    headerName: '참여자 수',
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createAdministratorNameCol({
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];

export const EntryParticipantListColumn: ColDef[] = [
  createIndexCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '응모 일시',
  }),
  createTypoCol({
    field: 'nick',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    headerName: '닉네임',
  }),
  createTypoCol({
    field: 'name',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.name || '-',
    headerName: '이름',
  }),
  createTypoCol({
    field: 'phone',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.phone ? formatter.PHONE(data?.customer?.phone) : '-',
    headerName: '핸드폰 번호',
  }),
  createTypoCol({
    field: 'customerAddress',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customerAddress || '-',
    headerName: '기본 주소',
  }),
  createCustomCol({
    field: 'entryCredit',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) => {
      return `${formatter.NUM_COMMA(data?.entryCredit)}`;
    },
    headerName: `응모 크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createTypoCol({
    field: 'signupSource',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) => {
      return data?.signupSource === null ? '에코야얼스' : data?.signupSource;
    },
    headerName: '가입 경로',
  }),
];
